"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Root = exports.classes = void 0;
const styles_1 = require("@mui/material/styles");
const PREFIX = "Bullets";
exports.classes = {
    li: `${PREFIX}-li`
};
exports.Root = (0, styles_1.styled)("ul")(({ theme }) => ({
    listStyle: "none",
    margin: 0,
    padding: 0,
    [`& .${exports.classes.li}:not(:last-child)`]: {
        marginBottom: "12px"
    },
    [`& .${exports.classes.li}`]: {
        "&::before": {
            display: "inline-block",
            content: '""',
            width: "9px",
            height: "9px",
            backgroundColor: theme.colours.accent,
            marginRight: "18px"
        }
    }
}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2J1bGxldHMvc3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLGlEQUE4QztBQUU5QyxNQUFNLE1BQU0sR0FBRyxTQUFTLENBQUM7QUFFWixRQUFBLE9BQU8sR0FBRztJQUNyQixFQUFFLEVBQUUsR0FBRyxNQUFNLEtBQUs7Q0FDbkIsQ0FBQztBQUVXLFFBQUEsSUFBSSxHQUFHLElBQUEsZUFBTSxFQUFDLElBQUksQ0FBQyxDQUFDLENBQUMsRUFBRSxLQUFLLEVBQUUsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUMvQyxTQUFTLEVBQUUsTUFBTTtJQUNqQixNQUFNLEVBQUUsQ0FBQztJQUNULE9BQU8sRUFBRSxDQUFDO0lBQ1YsQ0FBQyxNQUFNLGVBQU8sQ0FBQyxFQUFFLG1CQUFtQixDQUFDLEVBQUU7UUFDckMsWUFBWSxFQUFFLE1BQU07S0FDckI7SUFDRCxDQUFDLE1BQU0sZUFBTyxDQUFDLEVBQUUsRUFBRSxDQUFDLEVBQUU7UUFDcEIsV0FBVyxFQUFFO1lBQ1gsT0FBTyxFQUFFLGNBQWM7WUFDdkIsT0FBTyxFQUFFLElBQUk7WUFDYixLQUFLLEVBQUUsS0FBSztZQUNaLE1BQU0sRUFBRSxLQUFLO1lBQ2IsZUFBZSxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsTUFBTTtZQUNyQyxXQUFXLEVBQUUsTUFBTTtTQUNwQjtLQUNGO0NBQ0YsQ0FBQyxDQUFDLENBQUMifQ==